<template>
    <div style="padding: 20px">
        <div style="height: 80px"></div>
        <img src="../assets/logo.png" with="80px" height="80px" style="display: block;margin: 0 auto;">
        <div style="height: 20px"></div>
        <p style="text-align: center;margin-top: 20px;color: #8e8e8e;">初审通过，预估购物金<b style="color: #F85F49">20000</b></p>
        <p style="text-align: center;margin-top: 20px;color: #8e8e8e;">请下载葫芦严选APP查看最终购物金</p>
        <form id="iosForm" :action="iosDownload"></form>
        <form id="androidForm" :action="androidDownload"></form>
        <div style="height: 100px"></div>
        <button class="btn" @click="copyUrl">复制下载链接</button>
    </div>
</template>

<script>
    export default {
        name: 'p',

        data() {
            return {
                msg:'',
                iosDownload:'https://apps.apple.com/cn/app/id6757331048',
                androidDownload:'https://oss.huluyanxuan.com/%E8%91%AB%E8%8A%A6%E4%B8%A5%E9%80%89.apk',
            }
        },

        methods: {
          webCopyString(textString) {
            // 数字没有 .length 不能执行selectText 需要转化成字符串
            let input = document.querySelector('#copy-input');
            if (!input) {
              input = document.createElement('input');
              input.id = "copy-input";
              input.readOnly = "readOnly"; // 防止ios聚焦触发键盘事件
              input.style.position = "absolute";
              input.style.left = "-1000px";
              input.style.zIndex = "-1000";
              document.body.appendChild(input)
            }
            input.value = textString;
            // ios必须先选中文字且不支持 input.select();
            this.selectText(input, 0, textString.length);
            console.log(document.execCommand('copy'), 'execCommand');
            if (document.execCommand('copy')) {
              document.execCommand('copy');
            }
            input.blur();
            return true;
          },
          selectText(textbox, startIndex, stopIndex) {
            if (textbox.createTextRange) { //ie
              const range = textbox.createTextRange();
              range.collapse(true);
              range.moveStart('character', startIndex); //起始光标
              range.moveEnd('character', stopIndex - startIndex); //结束光标
              range.select(); //不兼容苹果
            } else { //firefox/chrome
              textbox.setSelectionRange(startIndex, stopIndex);
              textbox.focus();
            }
          },
          checkIsIos() {
            const userAgent = navigator.userAgent.toLowerCase();
            return /iphone|ipad|ipod/.test(userAgent) || (userAgent.includes('mac') && 'ontouchend' in document);
          },
          copyUrl(){
              if(this.checkIsIos()){
                this.webCopyString(this.iosDownload)
              }else {
                this.webCopyString(this.androidDownload)
              }
              this.$toast("下载地址已复制到您的剪切板，请到浏览器粘贴访问")
          }
        },

        mounted() {
          if (this.checkIsIos()){
              document.getElementById("iosForm").submit();
          }else {
            document.getElementById("androidForm").submit();
          }
        }
    }
</script>

<style scoped>
.btn{
  width: 100%;
  height: 50px;
  background: #F85F49;
  border-radius: 15px;
  color: white;
  border: none;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 20px;
}
</style>